// extracted by mini-css-extract-plugin
export default {"layout":"GlobalLayout_layout__3OITV","headerContainer":"GlobalLayout_headerContainer__oUt4+","dark":"GlobalLayout_dark__kFvZJ"};